import { API_URL, SUBSCRIBER_ENQUIRY_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${SUBSCRIBER_ENQUIRY_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchSubscriberEnquiry = async (lang: string) => {
  try {
    const subscriberEnquiryResponse = await fetchWithAuth(
      `${API_URL}/subscriber-enquiry?populate=OTTSalesChannels.Icon,ChatIcon,CallIcon,GA,OTTGA,SEO.MetaImage,OTTSEO.MetaImage&pagination[limit]=-1`,
      lang
    );

    const subscriberEnquiry = subscriberEnquiryResponse.data;

    console.log('fetchSubscriberEnquiry API Response:', subscriberEnquiry);
    return subscriberEnquiry;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};